import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  public passwordForm: FormGroup;

  constructor(private fb: FormBuilder, private auth: AuthService) {
    this.passwordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      //recaptcha: ['', Validators.required],
    });
  }

  ngOnInit(): void {}

  submit() {
    this.auth
      .resetPassword(this.passwordForm.value.email)
      .subscribe((data) => console.log(data));
  }
}
